export const TOKEN_KEY = "darwio_auth";
export const USER_KEY = "user";

export const HTTP_UNAUTHORIZED = 401;
export const HTTP_FORBIDDEN = 403;
